<template>
    <div>
        <fusioncharts
            type="hlineargauge"
            width="95%"
            :height="height"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
export default {
    props: {
        min: {
            type: Number,
            required: true
        },

        max: {
            type: Number,
            required: true
        },

        value: {
            type: Number,
            required: true
        },

        height: {
            type: Number,
            default: 50
        },

        title: {
            type: String,
            required: false
        }
    },

    computed: {
        dataSource() {
            return {
                chart: {
                    bgColor: "#FFFFFF",
                    baseFont: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"',
                    baseFontSize: 14,
                    caption: this.title,
                    lowerLimitDisplay: this.min,
                    upperLimitDisplay: this.max,
                    numberSuffix: "%",
                    chartBottomMargin: "0",
                    theme: "fusion",
                    showValue: "0",
                    majorTMNumber: "3",
                    minorTMColor: "#000000",
                    majorTMColor: "#000000",
                    labelFontColor: "#000000",
                    valueFontSize: 14,
                    pointerOnTop: "0",
                    gaugeFillMix: "{light-10},{light-30},{light-20},{dark-5},{color},{light-30},{light-20},{dark-10}",
                    gaugeFillRatio: "",
                },
                colorRange: {
                    color: [
                        {
                            minValue: this.min,
                            maxValue: this.max / 4
                        },
                        {
                            minValue: this.max / 4,
                            maxValue: this.max / 2
                        },
                        {
                            minValue: this.max / 2,
                            maxValue: this.max
                        }
                    ]
                },
                pointers: {
                    pointer: [
                        {
                            value: this.value
                        }
                    ]
                }
            };
        }
    },
}
</script>
